// generated from 64 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const featureFlagMembershipFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("feature_flag_membership_filter"),
  comparison_key: z.enum([
    "1", // 36 (56.25%)
    "2", // 28 (43.75%)
  ]),
  display_name: z.string(),
  // undefined: 5 (7.81%), defined 59 (92.19%)
  raw_value: common.objectId.optional(),
  value: z.object({
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
